import { Component, OnInit, ViewChildren, QueryList, OnDestroy, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { AssignmentCriteriaComponent } from '../assignment-criteria/assignment-criteria.component';
import { StateService } from '../state.service';
import { FormService } from '../../../form.service';
import { Subject } from 'rxjs/Subject';
import { ActivatedRoute } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { SemsoSnackbarService } from '../../../semso-snackbar.service';
import { HttpError } from '../../../errors';

@Component({
    selector: 'app-assignment',
    templateUrl: './assignment.component.html',
    styleUrls: ['./assignment.component.scss']
})
export class AssignmentComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChildren('assignmentCriteria') assignmentCriteria: QueryList<AssignmentCriteriaComponent>;

    public assignmentData;
    public validated = false;

    private formCode;
    private destroy$ = new Subject<boolean>();

    constructor(private stateService: StateService, private formService: FormService,
        private route: ActivatedRoute, private cd: ChangeDetectorRef, private snackbar: SemsoSnackbarService) { }

    ngOnInit() {
        this.route.params
        .takeUntil(this.destroy$)
        .subscribe(params => {
            this.formCode = params['formCode'];
            this.assignmentData = this.formService.getFormById(this.formCode)
            .takeUntil(this.destroy$)
            .pipe(catchError(e => {
                throw this.error(`Fout bij het ophalen van de opdrachtgegevens voor formulier: ${this.formCode}`)
            }))
        });
    }

    ngAfterViewInit() {
        this.cd.detectChanges();
    }

    ngOnDestroy() {
        this.destroy$.next(false);
    }

    validate() {
        if (!this.assignmentCriteria || this.assignmentCriteria.length === 0) {
            return false;
        }
        const errors = this.assignmentCriteria.filter(criteria => {
            return criteria.valid() === false;
        });

        this.updateState(errors.length === 0);
        setTimeout(() => {
            this.validated = errors.length === 0;
        })
    }

    private updateState(validated) {
        this.stateService.updateAssignment(validated);
    }

    private error(message) {
        this.snackbar.error(message);
        return new HttpError(message);
    }
}



// WEBPACK FOOTER //
// ./src/app/exam-preparation/determination-assignment-pvb/assignment/assignment.component.ts